import EformBaseService from "../../../../../services/EformBaseService";


export default class SasBeschwerdeformularService extends EformBaseService {

  constructor(props) {
    super('wbf/seco/sas/beschwerdeformular');
  }

}
